import { api } from "@shared/lib/api";
import { BackednResponse, IGetFaectValue } from "@shared/lib/types";
import {
  GetInfluencers,
  IAgencyInfluencerRequestFacets,
  ICreateInfluencerRequest,
  IInfluencerFacets,
  IInfluencerRequestAdd,
  IInfluencerRequests,
  IInfluencers,
  ILocationFacet,
} from "@shared/lib/types/influencer";

export class InfluencerService {
  public static async getInfluencerRequests(
    signal?: AbortSignal,
    searchQuery?: string,
    platform?: string[],
    category?: string[],
    agency?: string[],
    status?: string[],
    limit?: number,
    pageNo?: number
  ) {
    const params = new URLSearchParams();
    if (searchQuery) {
      params.append("searchQuery", searchQuery);
    }
    if (platform && platform.length) {
      params.append("platform", platform.join("$$"));
    }
    if (category && category.length) {
      params.append("category", category.join("$$"));
    }
    if (agency && agency.length) {
      params.append("agencyIds", agency.join("$$"));
    }
    if (status && status.length) {
      params.append("status", status.join("$$"));
    }
    if (limit) {
      params.append("limit", limit.toString());
    }
    if (pageNo) {
      params.append("pageNo", pageNo.toString());
    }

    const queryString = params.toString();
    const url = `agency/influencer/request${
      queryString ? `?${queryString}` : ""
    }`;
    const influencers = (await api
      .get(url, { signal })
      .json()) as BackednResponse<IInfluencerRequests>;
    return influencers;
  }

  public static async approveInfluencer(
    influencerAgencyRequestId: string,
    updatedDetails: ICreateInfluencerRequest,
    remarks?: string
  ) {
    await api.patch("agency/influencer/approve-request", {
      json: {
        influencerAgencyRequestId: influencerAgencyRequestId,
        updatedDetails: updatedDetails,
        remarks: remarks,
      },
    });
  }

  public static async rejectInfluencer(
    influencerAgencyRequestId: string,
    remarks?: string
  ) {
    await api.patch("agency/influencer/reject-request", {
      json: {
        influencerAgencyRequestId: influencerAgencyRequestId,
        remarks: remarks,
      },
    });
  }

  public static async getFacets() {
    return (await api
      .get("agency/influencer/request/facets")
      .json()) as BackednResponse<IAgencyInfluencerRequestFacets>;
  }
}
